import { FC, useState } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';

import { HamburgerMenuButton } from 'entities/HamburgerMenuButton';
import MiddleBarMainLogo from 'components/Header/MiddleBar/MainLogo';
import type { Block, Link } from 'src/__generated__/graphqlTypes';

import MobileHamburgerWrapper from './MobileHamburgerWrapper';
import styles from './styles.module.scss';
import QuickLinks from './QuickLinks';
import SignInButtonMobile from './SignInButtonMobile';
import HeaderMobileCTA from './HeaderMobileCTA';

import { IHeader } from '../config/declarations';
import { calculateMobileHeaderHeight } from '../lib';

const SearchBar = dynamic(() => import('entities/SearchBar').then((mod) => mod.SearchBar));
const HeaderTopBarMobile = dynamic(() => import('features/HeaderTopBar').then((mod) => mod.HeaderTopBarMobile));

const MobileHeader: FC<IHeader> = ({ header }) => {
  const height = calculateMobileHeaderHeight(header);
  const isHeaderCtaButton = Boolean(header.ctaButton);
  const isSimplifiedHeader = !header.nav && !header.searchBox;
  const [isStickyCtaActivated, setStickyCtaActivationState] = useState<boolean>(false);

  return (
    <>
      <MobileHamburgerWrapper header={header} />
      <header
        style={{ height }}
        className={cn(styles.header, styles.mobile)}
      >
        <div className={styles.container}>
          {!isSimplifiedHeader
            && <HeaderTopBarMobile topBar={header.top} />}
          <section className={cn(styles.head, {
            [styles.withCta]: isHeaderCtaButton && isStickyCtaActivated,
            [styles.simplified]: isSimplifiedHeader,
          })}
          >
            <HamburgerMenuButton
              button={header.hamburgerButton}
              className={styles.headHamburger}
            />
            <MiddleBarMainLogo
              isMobileView
              mainLogo={header.mainLogoMobile!}
              isStickyCtaActivated={isStickyCtaActivated}
            />
            <SearchBar
              search={header.searchBox}
              classNameIcon={styles.headSearch}
              isTooltip
            />
            {isSimplifiedHeader && (
              <SignInButtonMobile auth={header.authorization} />
            )}
            { isHeaderCtaButton && (
              <HeaderMobileCTA
                ctaButton={header.ctaButton as Block}
                isStickyCtaActivated={isStickyCtaActivated}
                setStickyCtaActivationState={setStickyCtaActivationState}
              />
            )}
          </section>
          <QuickLinks links={header.quickLinksCollection?.items as Array<Link>} />
        </div>
      </header>
    </>
  );
};

export default MobileHeader;
